import React from 'react';
const ContactUsPreamble = () => (
  <h4>
    We are available to help with questions, error reports, feature requests,
    dataset proposals, etc.
  </h4>
);

export default ContactUsPreamble;
